import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';
import { withFormsy } from 'formsy-react';
import debounce from 'lodash.debounce';

const FormInput = (
  {
    disabled,
    initialValue,
    errorMessage,
    name,
    onChange,
    setValue,
    showErrors,
    showRequired,
    timeout,
    type='text',
    value
  }) => {
  useEffect( () => setValue(initialValue), [initialValue]);
  const intl = useIntl();
  const error = showRequired ? intl.formatMessage({ id: 'employeeLogin.formInput.isRequired'} ) : errorMessage;

  const debounceOnChange = useRef(debounce(v => {
    onChange(v);
  }, timeout));

  const onInputChange = e => {
    const newValue = e.target.value;
    setValue(newValue);
    if(onChange){
      timeout ? debounceOnChange.current(newValue) : onChange(newValue);
    }
  };

  return <div key={name} className={`form-input form-input--${name}`}>
    <label htmlFor={name}>
      <FormattedMessage id={`employeeLogin.formInput.${name}`} />
      { showErrors && error ? <div className="form-input__error">{error}</div> : null }
    </label>
    <input
      type={type}
      name={name}
      placeholder={ intl.formatMessage({ id: `employeeLogin.formInput.${name}.placeholder` })}
      disabled={disabled}
      value={ value || '' }
      onChange={ onInputChange }
    />
  </div>;
};

FormInput.propTypes = {
  disabled: PropTypes.bool,
  errorMessage: PropTypes.any,
  initialValue: PropTypes.any,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  setValue: PropTypes.func,
  showRequired: PropTypes.bool,
  showErrors: PropTypes.bool,
  timeout: PropTypes.number,
  type: PropTypes.string,
  value: PropTypes.any,
};

export default withFormsy(FormInput);
